export function isNumber(value: any) {
  try {
    const numberValue = Number(value);
    return !isNaN(numberValue) && numberValue === value;
  } catch (error) {}

  return false;
}

export function formatMonetary(
  value: number | string | Number,
  minDecimal: number = 2,
  maxDecimal: number = 2
) {
  value = Number(value);
  if (!isNumber(value)) value = 0;

  return `R$ ${formatNumber(value, minDecimal, maxDecimal)}`;
}

export function formatNumber(
  value: number | string | Number,
  minDecimal: number = 2,
  maxDecimal: number = 2
) {
  if (typeof value == "string") {
    value = value.replace(".", "#");
    value = value.replace(",", ".");
    value = parseFloat(value.replace("#", "."));
  }
  value = Number(value);

  if (!isNumber(value)) return `0,00`;

  let primitiveValue: number = Number(value);

  if (Math.abs(primitiveValue) < Math.pow(10, -maxDecimal)) {
    primitiveValue = 0.0;
  }

  return primitiveValue.toLocaleString("PT-BR", {
    minimumFractionDigits: minDecimal,
    maximumFractionDigits: maxDecimal,
  });
}

export function NumberToString(num?: Number): string {
  if (!num) return "0";
  return String(num.valueOf());
}

export function convertByteToKb(size: number = 0) {
  return Math.trunc(size / 1024);
}

/**
 * Método responsável por retornar apenas a parte numérica de um campo no formato moeda
 * @param {string} originalValue string no formato de moeda
 * @returns {number | undefined} Número sem a formatação ou undefined caso não seja um NaN
 */
export function extractNumberFromText(
  originalValue: string
): number | undefined {
  let valueString = String(originalValue);

  // troca os pontos
  const lastIndexOfPeriod = valueString.lastIndexOf(".");
  const lastIndexOfComma = valueString.lastIndexOf(",");

  if (lastIndexOfPeriod < lastIndexOfComma)
    valueString = valueString.replace(/\./g, "").replace(",", ".");

  // remove o símbolo da moeda, virgulas e espaços
  valueString = valueString.replace(/([A-Z]{0,2}\$)|\s|\,/g, "");

  const num = Number(valueString);
  if (isNaN(num)) {
    return undefined;
  }

  // valueString = valueString.replace(/[^\d\.\-]+/g, "");
  return num;
}



// WEBPACK FOOTER //
// ./src/utils/MathUtils.ts